// components/DriverProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const DriverProtectedRoute = ({ children }) => {
   const token = sessionStorage.getItem('token');
   const userType = sessionStorage.getItem('userType');

   // If no token or not a driver
   if (!token || userType !== 'driver') {
      sessionStorage.clear();
      return <Navigate to="/login" replace />;
   }

   try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      // Token expired
      if (decoded.exp < currentTime) {
         sessionStorage.clear();
         return <Navigate to="/login" replace />;
      }
   } catch (err) {
      console.error('Driver token decode error:', err);
      sessionStorage.clear();
      return <Navigate to="/login" replace />;
   }

   return children;
};

export default DriverProtectedRoute;
